import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-azure-code-catch',
  templateUrl: './azure-code-catch.component.html',
  styleUrls: ['./azure-code-catch.component.scss'],
})
export class AzureCodeCatchComponent implements OnInit {
  constructor(private route: ActivatedRoute) { }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      if (params['code'] && window.opener) {
        const message = { code: params['code'] };
        // enviás el mensaje **directamente** al window.opener (el iframe)
        window.opener.postMessage(message, window.location.origin);
        window.close();
      }
    });
  }
}
